import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { cancelpolicyByPolicyID } from "../../../Service/_index";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";

// "Cancel Policy" (admin login, approved policies): asks for the reason, then cancels. The server zeroes the policy's payables /
// receivable (keeping what they held in cancelSnapshot) and refuses anything but an approved policy, so a refusal is shown here
// and the dialog stays open. `onCancelled` runs after a successful cancel (refresh the list / close the drawer).
const CancelPolicyDialog = ({ open, onClose, policy, onCancelled }) => {
  const [remarks, setRemarks] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) setRemarks("");
  }, [open, policy?._id]);

  const confirm = async () => {
    if (submitting || !remarks.trim() || !policy?._id) return;
    setSubmitting(true);
    try {
      const res = await cancelpolicyByPolicyID(policy._id, { cancelPolicyRemarks: remarks.trim() });
      if (!res || res.error) {
        ToastError(res?.message || "Failed to cancel policy");
        return;
      }
      ToastSuccess(res.message || "Policy cancelled successfully");
      onClose();
      if (onCancelled) onCancelled(res);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={!!open}
      onClose={submitting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, padding: 1 } }}
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          Confirm Cancel Policy{policy?.policyNumber ? ` - ${String(policy.policyNumber).replace(/'/g, "")}` : ""}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ backgroundColor: "#fff4f4", border: "1px solid #f5c2c7", borderRadius: 2, padding: 2, mb: 2, mt: 1 }}>
          <Typography variant="body2" color="error">
            The policy leaves the User Payable, Branch Payable and Commission Receivable lists and its amounts become 0.
            Please give the reason before cancelling.
          </Typography>
        </Box>
        <TextField
          label="Remark"
          variant="outlined"
          placeholder="Enter cancellation reason..."
          type="text"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          fullWidth
          autoFocus
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit" disabled={submitting}>
          Close
        </Button>
        <Button onClick={confirm} variant="contained" color="error" disabled={submitting || !remarks.trim()}>
          {submitting ? "Cancelling..." : "Confirm Cancel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelPolicyDialog;
